const LANGUAGE_NAMES: { [code: string]: string } = {
  en: 'English',
  hi: 'Hindi',
  hib: 'Hindi',
  te: 'Telugu',
  ta: 'Tamil',
  kn: 'Kannada',
  ml: 'Malayalam',
  bn: 'Bengali',
  mr: 'Marathi',
  pa: 'Punjabi',
  gu: 'Gujarati',
  or: 'Odia',
  ur: 'Urdu',
  as: 'Assamese',
  es: 'Spanish',
  fr: 'French',
  de: 'German',
  it: 'Italian',
  pt: 'Portuguese',
  ru: 'Russian',
  ja: 'Japanese',
  ko: 'Korean',
  zh: 'Chinese',
  ar: 'Arabic',
  // South Africa's official languages — HomeCinema's core catalogue is South
  // African, so these codes (ts, st, …) show up constantly and must resolve to
  // names rather than falling through to an uppercased code.
  af: 'Afrikaans',
  zu: 'Zulu',
  xh: 'Xhosa',
  st: 'Sesotho',
  nso: 'Sepedi',
  tn: 'Tswana',
  ts: 'Tsonga',
  ss: 'Swati',
  ve: 'Venda',
  nr: 'Ndebele',
  // Other African languages that appear in the catalogue.
  sw: 'Swahili',
  sn: 'Shona',
  yo: 'Yoruba',
  ig: 'Igbo',
  ha: 'Hausa',
  am: 'Amharic',
  id: 'Indonesian',
  tr: 'Turkish',
  nl: 'Dutch',
  pl: 'Polish',
  sv: 'Swedish',
  th: 'Thai',
  vi: 'Vietnamese'
};

export function getLanguageName(code: string): string {
  if (!code) return '';
  const normalized = code.toLowerCase().trim();
  return LANGUAGE_NAMES[normalized] || code.toUpperCase();
}

export function getLanguageNames(codes: string[] | null | undefined): string[] {
  if (!codes?.length) return [];
  const seen = new Set<string>();
  const names: string[] = [];
  for (const code of codes) {
    const name = getLanguageName(code);
    if (name && !seen.has(name)) {
      seen.add(name);
      names.push(name);
    }
  }
  return names;
}
